// extracted by mini-css-extract-plugin
export var actions = "_vf-4";
export var item = "_vf-1";
export var price = "_vf-3";
export var quantity = "_vf-2";
export var table = "_vf-0";